/**
 * utils.js
 */

/**
 * Converts a Base64 string to a PDF Blob and triggers a download.
 *
 * @param {string} base64String 
 * @param {string} filename 
 */
export function downloadPdfFromBase64(base64String, filename = `Saskaita-${Date.now()}.pdf`) {
	if (!base64String) return;

	const byteCharacters = atob(base64String);
	const byteNumbers = new Array(byteCharacters.length);
	for (let i = 0; i < byteCharacters.length; i++) {
		byteNumbers[i] = byteCharacters.charCodeAt(i);
	}
	const byteArray = new Uint8Array(byteNumbers);
	const blob = new Blob([byteArray], { type: 'application/pdf' });
	const blobUrl = URL.createObjectURL(blob);

	// Find the download button in the modal if it exists, otherwise create a temporary one
	let modalBtn = document.querySelector('.ig-success-download-btn');
	
	if (modalBtn) {
		modalBtn.href = blobUrl;
		modalBtn.download = filename;
		modalBtn.click();
	} else {
		const tempLink = document.createElement('a');
		tempLink.href = blobUrl;
		tempLink.download = filename;
		document.body.appendChild(tempLink);
		tempLink.click();
		document.body.removeChild(tempLink);
	}
}
